import { defineChain } from "viem";
import { DEV } from "./const";

export const pulsechain2 = /*#__PURE__*/ defineChain({
    id: 369,
    name: "PulseChain",
    nativeCurrency: { name: "Pulse", symbol: "PLS", decimals: 18 },
    testnet: false,
    rpcUrls: {
        default: {
            http: ["https://rpc.pulsechain.com"],
            webSocket: ["wss://ws.pulsechain.com"],
        },
    },
    blockExplorers: {
        default: {
            name: "PulseScan",
            url: "https://scan.pulsechain.com",
            apiUrl: "https://api.scan.pulsechain.com/api",
        },
    },
    contracts: {
        ensRegistry: {
            address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        },
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 14353601,
        },
    },
});

export const mainnet2 = /*#__PURE__*/ defineChain({
    id: 1,
    name: "Ethereum",
    nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
    rpcUrls: {
        default: {
            http: DEV ? ["http://127.0.0.1:8545/"] : ["https://ethereum-rpc.publicnode.com"],
            webSocket: DEV ? ["ws://127.0.0.1:8545/"] : ["wss://ethereum-rpc.publicnode.com"],
        },
    },
    blockExplorers: {
        default: {
            name: "Etherscan",
            url: "https://etherscan.io",
            apiUrl: "https://api.etherscan.io/api",
        },
    },
    contracts: {
        ensRegistry: {
            address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        },
        ensUniversalResolver: {
            address: "0xce01f8eee7E479C928F8919abD53E553a36CeF67",
            blockCreated: 19_258_213,
        },
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 14_353_601,
        },
    },
});
